/* Shiro theme: vanilla JS, no dependencies */
(function () {
  'use strict';
  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Accordions (animated with CSS grid rows) */
  function toggleAcc(item, forceOpen) {
    if (!item) return;
    var open = forceOpen === true ? true : !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    var btn = qs('[data-acc-btn]', item);
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* Gallery */
  function showMedia(root, id) {
    if (!root || !id) return;
    id = String(id);
    qsa('[data-media-id]', root).forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-media-id') === id);
    });
    qsa('[data-thumb]', root).forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-thumb') === id);
    });
  }

  function stepMedia(root, dir) {
    var slides = qsa('[data-media-id]', root);
    if (slides.length < 2) return;
    var i = 0;
    slides.forEach(function (el, n) { if (el.classList.contains('is-active')) i = n; });
    var next = (i + dir + slides.length) % slides.length;
    showMedia(root, slides[next].getAttribute('data-media-id'));
    var th = qs('[data-thumb].is-active', root);
    if (th && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }

  /* Toast */
  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4500);
  }

  function setCartCount(n) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  /* Delegated clicks */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var burger = t.closest('[data-menu-toggle]');
    if (burger) {
      var header = burger.closest('.site-header');
      var open = !header.classList.contains('is-open');
      header.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var accBtn = t.closest('[data-acc-btn]');
    if (accBtn) { toggleAcc(accBtn.closest('[data-acc-item]')); return; }

    var opener = t.closest('[data-open-acc]');
    if (opener) {
      e.preventDefault();
      var item = document.getElementById(opener.getAttribute('data-open-acc'));
      if (item) {
        toggleAcc(item, true);
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    var mstep = t.closest('[data-media-step]');
    if (mstep) { stepMedia(mstep.closest('[data-product]'), parseInt(mstep.getAttribute('data-media-step'), 10)); return; }

    var thumb = t.closest('[data-thumb]');
    if (thumb) { showMedia(thumb.closest('[data-product]'), thumb.getAttribute('data-thumb')); return; }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = qs('input', step.parentNode);
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, next);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var h = qs('.site-header.is-open');
    if (h) {
      h.classList.remove('is-open');
      var b = qs('[data-menu-toggle]', h);
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    }
  });

  /* Product page */
  function initProduct(root) {
    if (root.__shiro) return;
    root.__shiro = true;

    var form = qs('[data-product-form]', root);
    var dataEl = qs('[data-variants]', root);
    if (!form || !dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var idInput = qs('[data-variant-id]', form);
    var priceEl = qs('[data-price]', root);
    var compareEl = qs('[data-compare]', root);
    var saleEl = qs('[data-sale]', root);
    var addBtn = qs('[data-add]', form);
    var addLabel = qs('[data-add-label]', form);
    var buyBtn = qs('[data-buy]', form);
    var fieldsets = qsa('.opt', form);
    var stockEl = qs('[data-stock]', root);
    var stockLow = parseInt(root.getAttribute('data-stock-low'), 10) || 0;
    var sticky = qs('[data-sticky]', root);
    var stickyPrice = qs('[data-sticky-price]', root);
    var stickyBtn = qs('[data-sticky-buy]', root);
    var labels = {
      add: addLabel ? addLabel.textContent : 'Ajouter au panier',
      soldOut: form.getAttribute('data-sold-out') || 'Épuisé',
      unavailable: form.getAttribute('data-unavailable') || 'Indisponible'
    };
    var defaultAdd = form.getAttribute('data-add-text') || 'Ajouter au panier';

    function update() {
      var selected = fieldsets.map(function (fs) {
        var c = qs('input:checked', fs);
        var l = qs('[data-option-label]', fs);
        if (c && l) l.textContent = c.value;
        return c ? c.value : null;
      });
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === selected[i]; });
      })[0];
      var ok = !!(v && v.available);

      if (v) {
        idInput.value = v.id;
        priceEl.textContent = v.price;
        var onSale = v.compare_raw && v.compare_raw > v.price_raw;
        compareEl.textContent = onSale ? v.compare : '';
        compareEl.hidden = !onSale;
        if (saleEl) { saleEl.hidden = !onSale; if (onSale && v.save) saleEl.textContent = '-' + v.save + ' %'; }
        if (stickyPrice) stickyPrice.textContent = v.price;
        if (v.media) showMedia(root, v.media);
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(null, '', url.toString());
        }
      }
      if (addLabel) addLabel.textContent = !v ? labels.unavailable : ok ? defaultAdd : labels.soldOut;
      if (addBtn) addBtn.disabled = !ok;
      if (buyBtn) buyBtn.disabled = !ok;
      if (stickyBtn) stickyBtn.disabled = !ok;
      if (stockEl) {
        if (!v || !ok) { stockEl.hidden = true; }
        else if (stockLow && v.track && v.stock > 0 && v.stock <= stockLow) {
          stockEl.className = 'pdp__stock is-low';
          stockEl.textContent = 'Plus que ' + v.stock + ' en stock';
          stockEl.hidden = false;
        } else {
          stockEl.className = 'pdp__stock';
          stockEl.textContent = 'En stock';
          stockEl.hidden = false;
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') update();
    });

    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (sub && sub.name === 'checkout') return; /* Buy now: native submit goes straight to checkout */
      e.preventDefault();
      if (addBtn.disabled) return;

      var original = addLabel.textContent;
      addBtn.disabled = true;
      addLabel.textContent = form.getAttribute('data-adding-text') || 'Ajout en cours...';

      fetch(form.getAttribute('data-cart-add-url'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || "Impossible d'ajouter cet article");
          return fetch(form.getAttribute('data-cart-url') + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setCartCount(cart.item_count);
          addLabel.textContent = form.getAttribute('data-added-text') || 'Ajouté';
          toast('<span>' + (form.getAttribute('data-added-text') || 'Ajouté au panier') + '</span><a href="' + form.getAttribute('data-cart-url') + '">' + (form.getAttribute('data-view-cart') || 'Voir le panier') + '</a>');
          setTimeout(function () { addLabel.textContent = original; addBtn.disabled = false; }, 1600);
        })
        .catch(function (err) {
          addLabel.textContent = original;
          addBtn.disabled = false;
          toast('<span>' + err.message + '</span>');
        });
    });

    /* Sticky buy bar (mobile): shows once the main buy button has scrolled out of view */
    var buyRow = qs('.buy', form);
    if (sticky && buyRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var r = en[0];
        var show = !r.isIntersecting && r.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(buyRow);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', function () { if (buyBtn && !buyBtn.disabled) buyBtn.click(); });

    /* Swipe on the gallery */
    var stage = qs('[data-stage]', root);
    if (stage) {
      var sx = 0, sy = 0;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) stepMedia(root, dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    update();
  }

  /* Recommendations: fetched only when scrolled near, keeps first load light */
  function initRecs(el) {
    if (el.__shiro) return;
    el.__shiro = true;
    var url = el.getAttribute('data-url');
    if (!url) return;
    var load = function () {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var tmp = document.createElement('div');
          tmp.innerHTML = text;
          var src = qs('[data-recommendations]', tmp);
          if (src && src.innerHTML.trim()) { el.innerHTML = src.innerHTML; initReveal(el); }
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '400px' });
      io.observe(el);
    } else { load(); }
  }

  /* Scroll reveal: elements fade and rise once when they enter the viewport */
  var revealIO;
  function initReveal(scope) {
    var els = qsa('[data-reveal]:not(.is-in)', scope);
    if (!els.length) return;
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (!('IntersectionObserver' in window) || inEditor) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { revealIO.observe(el); });
  }

  /* Reviews carousel: arrows scroll by one card, disabled at the ends */
  function initReviews(root) {
    if (root.__shiro) return;
    root.__shiro = true;
    var track = qs('[data-rv-track]', root);
    var sec = root.closest('section') || document;
    var prev = qs('[data-rv-prev]', sec);
    var next = qs('[data-rv-next]', sec);
    if (!track) return;
    function step() {
      var card = qs('.rv__card', track);
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* Estimated delivery dates, formatted in French */
  function initDelivery(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || 3);
    try {
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      var a = new Date(); a.setDate(a.getDate() + min);
      var b = new Date(); b.setDate(b.getDate() + max);
      el.textContent = 'Livraison estimée : ' + fmt.format(a) + ' – ' + fmt.format(b);
      el.hidden = false;
    } catch (e) {}
  }

  /* Header gets a soft shadow once the page is scrolled */
  function initHeader() {
    var h = qs('.site-header');
    if (!h) return;
    var on = function () { h.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  function init(scope) {
    qsa('[data-product]', scope).forEach(initProduct);
    qsa('[data-recommendations]', scope).forEach(initRecs);
    qsa('[data-reviews]', scope).forEach(initReviews);
    qsa('[data-delivery-est]', scope).forEach(initDelivery);
    initReveal(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); initHeader(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
